(function() {
    'use strict';
    
a3_cabin_reports.controller('BarTrolleyCtrl', BarTrolleyCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name BarTrolleyCtrl
    * @description 
    *  Manages the Bar Trolley Modal View
    * @ngInject
    */
function BarTrolleyCtrl($scope, $uibModalInstance, ModalDialogResultFactory, BarTrolleyFactory, bart) {

		var result = ModalDialogResultFactory.createNew();

		if (bart == null) {
			result.Object = BarTrolleyFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = BarTrolleyFactory.fromObject(bart);
			result.isInsertMode = false;
		}

		$scope.bart = result.Object;
        $scope.ok = ok;
		$scope.cancel = cancel;
            
        /**
         * Close modal after u check position
         * @memberof BarTrolleyCtrl
         */
        function ok() {
			if ((result.Object.Position == null) || (result.Object.Position == ''))
				result.Object.Position = '-';
			$uibModalInstance.close(result);
		}

        /**
         * Close Modal
         * @memberof BarTrolleyCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();
